import React from "react";
import { VipProgress } from "@housebets/housebets-x-package";
import { useRewardProgressData } from "./hooks/useRewardProgressData";
import { useIntl } from "react-intl";

export const RewardProgress: React.FC = () => {
    const { revard, nextRevard } = useRewardProgressData();
    const {$t} = useIntl();

    return (
        <VipProgress
            revard={revard}
            nextRevard={nextRevard}
            texts={{
                currentReward: $t({ id: 'VipProgress.currentReward' }),
                nextReward: $t({ id: 'VipProgress.nextReward' }),
                description: $t({ id: 'VipProgress.description' }),
                title: $t({ id: 'VipProgress.title' }),
                upToNext: $t({ id: 'VipProgress.nextLevel' }),
            }}
        />
    );
};

RewardProgress.displayName = "RewardProgress";
